var oldScrollY = window.scrollY;
var stickyNav = document.getElementsByClassName('split-header__bottom');
window.onscroll = function (e) {  
    if(stickyNav.length) {
        this.oldScroll = this.scrollY;
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop
        if(scrollTop > 480) {   
            stickyNav[0].classList.add('stickyNav')
            if(oldScrollY > window.scrollY) {
                stickyNav[0].classList.add('scrollUp')
            } else {
                stickyNav[0].classList.remove('scrollUp')
            }
            oldScrollY = window.scrollY;
        }
        else {
            stickyNav[0].classList.remove('stickyNav')
        }
    }
} 